<template>
  <div class="stemwijzer-cta">
    <div class="container">
      <div class="content-wrapper">
        <img class="logo" src="images/stem.svg" />
        <div class="text-container">
          {{ description }}
        </div>

        <CTA :small="true" color="blue" :href="href" target="_blank" :label="link" />
      </div>

      <button class="close-button" @click="closeCTA()">
        <font-awesome-icon icon="fa-solid fa-circle-xmark" class="close" />
      </button>
    </div>
  </div>
</template>

<script>
import CTA from "@/components/UI/CTA";
import { mapState } from "vuex";

export default {
  components: {
    CTA,
  },

  computed: {
    ...mapState({
      description: (state) => state.dictionary.stemwijzerCTA.description,
      link: (state) => state.dictionary.stemwijzerCTA.link,
      href: (state) => state.dictionary.stemwijzerCTA.href,
    }),
  },

  methods: {
    closeCTA() {
      this.$emit("closeCTA");
    },
  },
};
</script>

<style lang="scss" scoped>
.stemwijzer-cta {
  position: fixed;
  top: 0px;
  z-index: 1000;
  width: 100%;
  left: 0px;

  @include media(">phone") {
    max-width: 325px;
    padding: 20px;
  }

  @include media("<=phone") {
    padding: 15px;
  }
}

.container {
  position: relative;
  background: white;
  border-radius: $border-radius;
  overflow: hidden;
  padding: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
}

.content-wrapper {
  display: flex;
  flex-direction: column;
}

.logo {
  width: 100%;
  max-width: 150px;
  height: auto;
  flex-shrink: 0;
  margin-bottom: 15px;
}

.text-container {
  font-size: 16px;
  margin-bottom: 15px;
}

.close-button {
  font-size: 22px;
  position: absolute;
  right: 10px;
  top: 10px;
  color: $pink;
  cursor: pointer;
  border: 0;
  background: transparent;
  -webkit-appearance: none;
}
</style>
